import "./ButtonGlobal.scss";

const ButtonGlobal = ({ cb, text, back, iconLeft = false }) => {
  const handleCb = () => {
    if (cb) {
      cb();
    }
  };
  return (
    <button
      className={`global__button${back ? " back" : ""}`}
      onClick={handleCb}
    >
      {iconLeft && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 12H19M5 12L11 18M5 12L11 6"
            stroke="#111212"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {text}
    </button>
  );
};
export default ButtonGlobal;
